
import { Product } from "@/types/product";

export const hdmiSwitchers: Product[] = [
  {
    id: "dxe-218",
    groupId: "hdmi-switchers",
    name: "DXE-218",
    description: "The DXE-218 is the first ever 2 Input/8 Port 4K60 Advanced HDMI® Splitter with downscaling per individual output. The unit delivers enhanced capabilities such as individual CEC control, EDID management, Hot Plug Detection, and EDID reporting per output. This is all done through the LAN port for full control and statistics of all ports. In addition, the downscaling per port allows 1080p screens to be utilized on the same splitter with a 4K60 source. To round out the solution, the DXE-218 has 2 input ports to select from to change content remotely. The PoE simplifies cabling by eliminating all external power supplies. Depending on the network switch, the DXE-218 can even be power controlled remotely. The DXE-218 is the perfect solution for any HDMI® distribution providing the best in remote support, control, and capability.",
    features: [
      "2 HDMI inputs",
      "8 HDMI outputs",
      "Resolutions up to 4K2K @ 60Hz 4:4:4",
      "Per port downscaling to 1080p",
      "LAN port",
      "PoE (Power over Ethernet)",
      "CEC control",
      "EDID management",
      "Hot plug detection",
      "EDID reporting",
      "Front LED status display"
    ],
    specifications: [
      "Technical",
      "HDMI/DVI Compliance: HDMI 2.0A Deep Color, full 3D & 4K2K / DVI 1.0",
      "HDCP Compliance: HDCP 1.4/2.2",
      "Video Bandwidth: Single-link 600MHz [18Gbps]",
      "Video Support: Up to 4K2K @60fps",
      "Downscaling: Automatic and Independent per port 4K to 1080p",
      "Audio Support: DTS-HD Master Audio, Dolby TrueHD Dolby Digital, DTS, DVD-Audio, LPCM, SACD, MPCM",
      "Firmware Update: Mini-USB Port",
      "Input: 2x HDMI 2.0A",
      "Output: 8x HDMI 2.0A",
      "EDID: Auto Management & Custom",
      "LAN: 10/100Mbps PoE RJ-45",
      "Power Supply Included: Non PoE version power supply included.",
      "Mechanical",
      "Housing: Metal Enclosure",
      "Dimensions [L x W x H]: 317.7 x 84.7 x 30mm (12.51\" x 3.33\" x 1.18\")",
      "Weight: 784g (1.73 lbs)",
      "Mounting: Wall/Desk Mount Ears",
      "Power Supply / Included: 12V 2A DC",
      "Power Consumption: 12 Watts [max]",
      "Operation Temperature: 0 - 55 Celsius",
      "Storage Temperature: -20 - 60 Celsius",
      "Relative Humidity: 20 - 90% RH [no condensation]"
    ],
    image: "/lovable-uploads/de27450c-e5d3-45b7-a895-798754d5a414.png",
    images: [
      "/lovable-uploads/de27450c-e5d3-45b7-a895-798754d5a414.png",
      "/lovable-uploads/31d19994-b169-4955-ac33-254294c09875.png"
    ],
    slug: "dxe-218"
  },
  {
    id: "dxe-142a-ds",
    groupId: "hdmi-switchers",
    name: "DXE-142A-DS",
    description: "The DXE-142A-DS 1×4 HDMI 2.0A 4K Splitter with Auto EDID Management provides one of the most advanced HDMI splitter solutions by which the Ultra High Definition video and high quality audio can be transmitted to multiple locations without losing quality. The DXE-142A-DS supports all 3D formats and true 4K2K video. EDID management can be one of the most important capabilities to a splitter. Taking it one step further Aurora has added the ability to customize EDID for complete EDID emulation. This allows full control over the source and what it will be allowed to do. The DXE splitter have firmware upgrade capability via the USB port ensures compatibility now and in the future. With 48bit deep color video and high definition audio support, the DXE-142A-DS is suitable for high quality HDMI broadcasting, conference room, digital signage and education applications.",
    features: [
      "Supports HDMI 2.0A Deep Color & 3D / DVI 1.0 compliant",
      "HDCP 1.4/2.2 compliant",
      "Wide frequency range: 25MHz~600MHz"
    ],
    specifications: [
      "Technical",
      "HDMI/DVI compliance: HDMI 2.0A Deep Color, full 3D & 4K2K/ DVI 1.0",
      "HDCP compliance: HDCP 1.4/2.2",
      "Video bandwidth: Single-link 600MHz [18Gbps]",
      "Video support: Up to 4K2K @60",
      "HDMI Output Distance: 720p 12bit up to 20m, 1080i 12bit up to 20m, 1080p 12bit up to 15m, 4K up to 7.5m (Note: Cable quality may impact distance)",
      "Audio support: DTS-HD Master Audio, Dolby TrueHD Dolby Digital, DTS, DVD-Audio, LPCM, SACD, MPCM",
      "Firmware update: Mini-USB port",
      "Input: 1x HDMI",
      "Output: 4x HDMI",
      "EDID: Auto Management",
      "Mechanical",
      "Housing: Metal enclosure",
      "Dimensions [L x W x H]: 150 x 70 x 11mm (5.91\"x2.76\"x0.433\")",
      "Weight: 0.12kg (4.23oz)",
      "Mounting: Attachable ears",
      "Power supply: 5V 1A DC",
      "Power consumption: 3.6 Watts [max]",
      "Operation temperature: 0~55°C",
      "Storage temperature: -20~60°C [-4~140°F]",
      "Relative humidity: 10~90% RH [no condensation]"
    ],
    image: "/lovable-uploads/e9c4849e-ad67-4610-89c3-932c8c983a2e.png",
    images: [
      "/lovable-uploads/e9c4849e-ad67-4610-89c3-932c8c983a2e.png",
      "/lovable-uploads/dfc5d6f0-84c7-4015-9e96-fa8260df928e.png"
    ],
    slug: "dxe-142a-ds"
  }
];
